import dynamic from 'next/dynamic'
import { TRACK_CONTENT_TYPES } from '@mc/track-event'
import CTA from 'components/CTA'
import { getCourseModalText } from 'components/VideoModal/getCourseModalText'
import { type PrunedCourse } from 'libs/server/api'
import { type TrailerModalLocation } from '../events'

const VideoModal = dynamic(() => import('components/VideoModal'), {
  ssr: false,
})

export interface TrailerProps {
  mediaUuid?: string | null
  modalTitle?: string | null
  tagline?: string | null
  id?: string | number | null
  slug?: string | null
  title?: string | null
  instructorAvatar?: string | null
}

export const getCourseTrailerProps = (course: PrunedCourse): TrailerProps => ({
  mediaUuid: course.mediaUuid,
  ...getCourseModalText(course),
  id: course.id,
  slug: course.slug,
  title: course.title,
  instructorAvatar: course.primary1x1,
})

// The modal plays `mediaUuid` only, so that alone decides whether a trailer is
// playable — `brightcoveVideoId` is never passed and must not be added here.
export const hasCourseTrailer = (
  trailer?: Pick<TrailerProps, 'mediaUuid'> | null,
): boolean => Boolean(trailer?.mediaUuid)

type CourseTrailerModalProps = {
  trailer: TrailerProps
  location: TrailerModalLocation
  onClose: () => void
  /** Fires on every play, including unpausing — de-dupe at the call site. */
  onPlay?: () => void
}

export const CourseTrailerModal = ({
  trailer,
  location,
  onClose,
  onPlay,
}: CourseTrailerModalProps) => (
  <VideoModal
    show
    onCloseModal={onClose}
    onPlay={onPlay}
    mediaUuid={trailer.mediaUuid || ''}
    modalTitle={trailer.modalTitle}
    tagline={trailer.tagline}
    contentId={`${trailer.id}_${trailer.mediaUuid}`}
    contentTitle={trailer.title || ''}
    contentType={TRACK_CONTENT_TYPES.COURSE_TRAILER}
    courseId={trailer.id || 0}
    instructorAvatar={trailer.instructorAvatar}
    buttonGroup={
      <CTA
        trackProps={{
          category: 'need-to-know',
          class: trailer.slug,
          content_type: 'product',
          location,
          page_category: 'personalization',
        }}
      />
    }
  />
)
